import { Link } from "react-router-dom";
import { HandySvg } from "handy-svg";
import iconLogoTV from "../../assets/images/elems/logo-tv.svg";
import iconOKFull from "../../assets/icons/svg-sprite/odnoklassniki-full.svg";
import iconPhone from "../../assets/icons/svg-sprite/phone.svg";
import iconVKFull from "../../assets/icons/svg-sprite/vkontakte-full.svg";
import appStoreButton from "../../assets/images/elems/app_store_button.jpg";
import googlePlayButton from "../../assets/images/elems/google_play_button.jpg";

const Footer = () => {
  return (
    <>
      <footer className="footer page__footer">
        <div className="footer__top footer__container page-container">
          <div className="footer__menu">
            <div className="footer__menu-inner">
              <div className="footer__menu-column">
                <h4 className="footer__menu-title title title--h4">
                  Подключение
                </h4>
                <ul className="footer__menu-list">
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/where_to_buy/"
                    >
                      Где купить?
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/subscription_agreement/"
                    >
                      Абонентский договор
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//shop.telekarta.tv"
                    >
                      Интернет-магазин
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//onlinetv.telekarta.tv"
                    >
                      Онлайн-кинотеатр
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer__menu-column">
                <h4 className="footer__menu-title title title--h4">
                  Абонентам
                </h4>
                <ul className="footer__menu-list">
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/payment/"
                    >
                      Оплатить подписку
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/exchange/"
                    >
                      Обменять оборудование
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/actions/"
                    >
                      Акции
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/tvprogram/"
                    >
                      Телепрограмма
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/tvprogram/channels/"
                    >
                      Телеканалы
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/bonus/"
                    >
                      Телекарта Бонус
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/instructions/"
                    >
                      Инструкции
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/where_to_buy?type=service"
                    >
                      Гарантийное обслуживание
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer__menu-column">
                <h4 className="footer__menu-title title title--h4">
                  О Телекарте
                </h4>
                <ul className="footer__menu-list">
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/about/"
                    >
                      О Телекарте
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/contacts/"
                    >
                      Контакты и реквизиты
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/licenses/"
                    >
                      Лицензия
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/partners/"
                    >
                      Партнёрам
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/oborudovanie/"
                    >
                      Архив оборудования
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/brand/print/"
                    >
                      Рекламные материалы
                    </Link>
                  </li>
                  <li className="footer__menu-item">
                    <Link
                      className="footer__menu-link"
                      to="//telekarta.tv/support/faq/"
                    >
                      Вопросы и ответы
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer__contacts">
            <div className="footer__phone">
              <button className="footer__phone-link js-support-callback-trigger">
                <HandySvg
                  className="svg-icon footer__phone-icon"
                  src={iconPhone}
                  width="22"
                  height="22"
                />
                <span className="footer__phone-text">8 (800)-100-104-7</span>
              </button>
              <button
                className="footer__phone-link js-support-callback-trigger"
                style={{ marginTop: 10 }}
              >
                <HandySvg
                  className="svg-icon footer__phone-icon"
                  src={iconPhone}
                  width="22"
                  height="22"
                />
                <span className="footer__phone-text">8 (495)-781-41-03</span>
              </button>
            </div>
            <div className="footer__socials">
              <h4 className="footer__socials-title title title--h4">
                Социальные сети
              </h4>
              <section className="socials-rainbow socials-rainbow--footer">
                <h6 className="visuallyhidden">Ссылки на социальные сети</h6>
                <Link
                  className="socials-rainbow__link"
                  to="https://vk.com/tvtelekarta"
                  target="_blank"
                >
                  <span className="visuallyhidden">
                    Ссылка на группу вконтакте
                  </span>
                  <HandySvg
                    className="svg-icon"
                    src={iconVKFull}
                    width="40"
                    height="40"
                  />
                </Link>
                <Link
                  className="socials-rainbow__link"
                  to="https://ok.ru/telekarta.tv"
                  target="_blank"
                >
                  <span className="visuallyhidden">
                    Ссылка на группу в одноклассниках
                  </span>
                  <HandySvg
                    className="svg-icon"
                    src={iconOKFull}
                    width="40"
                    height="40"
                  />
                </Link>
              </section>
            </div>
            <div class="footer__stores">
              <Link
                class="footer__stores_item"
                to="https://play.google.com/store/apps/details?id=com.telekarta.lkabonentandroid"
                target="_blank"
              >
                <img src={googlePlayButton} />
              </Link>
              <Link
                class="footer__stores_item"
                to="https://apps.apple.com/ru/app/%D0%BC%D0%BE%D1%8F-%D1%82%D0%B5%D0%BB%D0%B5%D0%BA%D0%B0%D1%80%D1%82%D0%B0/id1639866833"
                target="_blank"
              >
                <img src={appStoreButton} />
              </Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom footer__container page-container">
          <div className="footer__copyright">
            <Link className="footer__copyright-logo" to="/">
              <img
                src={iconLogoTV}
                width="202"
                height="51"
                alt="Телекарта логотип"
              />
            </Link>
            <p className="footer__copyright-text">
              © 2026 ООО «ТЕЛЕКАРТА» — спутниковое телевидение ООО «ОРИОН
              ЭКСПРЕСС»
              <br />
              <Link
                className="link"
                to="https://static.telekarta.tv/policy/PrivacyPolicyOrion.pdf"
                target="_blank"
                style={{ fontSize: "0.65rem" }}
              >
                Политика обработки персональных данных в ООО «ОРИОН ЭКСПРЕСС»
              </Link>
              <br />
              <Link
                className="link"
                to="https://static.telekarta.tv/policy/PrivacyPolicyTelekarta.pdf"
                target="_blank"
                style={{ fontSize: "0.65rem" }}
              >
                Политика обработки персональных данных в ООО «Телекарта»
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
